module.exports = __webpack_public_path__ + "img/Iris_Logo_Light_Grey_Shadow.d9670628.svg";